module.exports = __webpack_public_path__ + "img/picwish(1).6bb601ca.png";